import React, { useEffect, useState } from "react";
import uuid from "uuid/dist/v4";
import { addComment } from "../actions/articleActions";
import Loading from "./Loading";
import decode from "jwt-decode";
import "react-icons/fc";

import { useSelector, useDispatch } from "react-redux";

const Comments = ({ comments, id }) => {
  const [comment, setComment] = useState("");
  const [commentList, setCommentList] = useState();

  const user = useSelector((state) => state.session);
  const dispatch = useDispatch();
  useEffect(() => {
    setCommentList(comments);
  }, [comments]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      id: uuid(),
      userId: user?.accessToken ? `${decode(user.accessToken).id}` : uuid() + 1,
      userName: user?.accessToken
        ? `${decode(user.accessToken).name}`
        : "Anonymous",
      avatar: user?.accessToken
        ? `${decode(user.accessToken).name.split(" ")[0].charAt(0)}${decode(
            user?.accessToken
          )
            .name.split(" ")[1]
            .charAt(0)}`
        : "Guest",
      text: comment,
      articleId: id,
    };

    const resultError = await addComment(data);
    setCommentList((prev) => [...prev, data]);
    if (!resultError.ratingFound) {
      dispatch({ type: "RATING", payload: true });
    }
    setComment("");
  };
  if (!commentList) return <Loading />;
  return (
    <>
      <div className="comment-container">
        <div className="comment">
          <div className="user">
            {user?.accessToken
              ? `${decode(user.accessToken)
                  .name.split(" ")[0]
                  .charAt(0)}${decode(user?.accessToken)
                  .name.split(" ")[1]
                  .charAt(0)}`
              : "Guest"}
          </div>
          <form className="actions" onSubmit={handleSubmit}>
            <input
              type="text"
              name="comment"
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Write a comment..."
              maxLength="100"
            />

            {/* <button type="submit">Send</button> */}
          </form>
        </div>

        <div className="allComments-container">
          {commentList
            .slice()
            .reverse()
            .map((data) => {
              const { text, avatar, id, userName } = data;
              return (
                <div key={id} className="comment">
                  <div className="user">{avatar ? avatar : "Guest"}</div>
                  <div className="comment-details">
                    <div className="position">
                      <p>{userName ? userName : "Guest"}</p>
                      <p style={{ fontSize: "0.7rem" }} className="text">
                        {text}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Comments;
